import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import { DeleteIcon, DownloadIcon, EditIcon } from "core/Icons";
import ClientHelper from "core/ClientHelper";
import PropTypes from "prop-types";
import React from "react";
import { GenericAlert, GenericGrid, GenericLabel, GenericSelectInput, GenericTextInput, GenericTitle } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import GridButton from "views/Components/GridButton";
import { UserStatus } from "views/Constants/Constant";

class PaymentAdminDocument extends React.Component {
	constructor(props) {
		super(props);
		this.UploadClick = this.UploadClick.bind(this);
		this.FileSelect = this.FileSelect.bind(this);
		this.UpdateModel = this.UpdateModel.bind(this);
		this.UpdateFile = this.UpdateFile.bind(this);
		this.ParameterDocumentVerifiedStatusType = { ParameterCode: "LOSVerifiedStatus" };
		this.VerifyingPersonParameterCode = { ParameterCode: "IdentityVerifyingPerson" };
		this.fileInputRef = React.createRef();

		this.emptyObject = {};

		this.sortedFullName = { Member: "FullName" };

		this.state = {

			vModel: {},
			documentModel: { File: { FileName: "" } },
			documentList: [],
			isLoading: false,
			alert: null
		};
		this.ParameterDocumentType = { ParameterCode: "LOSDocumentType" };

		this.ColumnsData = [
			{
				Header: "Actions",
				accessor: "Actions",
				Cell: row => (
					<div>
						<GridButton
							tooltip="Edit"
							Icon={EditIcon}
							OnClick={() => this.setState({ documentModel: { ...row.original } })} />
						<GridButton
							tooltip="Delete"
							Icon={DeleteIcon}
							OnClick={() => this.showQuestionMessage("Delete this record !", row.original)} />
						<GridButton
							Disabled={this.props.Disabled}
							tooltip="Download"
							Icon={DownloadIcon}
							OnClick={() => this.DownloadFile(row.original)} />
					</div>
				),
				sortable: false,
				filterable: false,
				width: 100
			},
			{
				Header: "Document Type",
				accessor: "DocumentType.ParameterDesc"
			},
			{
				Header: "Verification Status",
				accessor: "VerificationStatus.ParameterDesc"
			},
			{
				Header: "Verified Person",
				accessor: "VerifiedPerson.ParameterDesc"
			}
		];
	}
	componentDidMount() {
		if (this.props.setAppLeftTitle)
			this.props.setAppLeftTitle("Documents");


		var model = { Id: 0 };
		this.setState({ documentModel: model, ApplicationDocumentList: this.props.ApplicationDocumentList });

	}
	UploadClick() {
		this.fileInputRef.current.click();
	}

	FileSelect(e) {
		e.preventDefault();

		var file = e.target.files[0];
		if (!file) return;
		var documentModel = this.state.documentModel;
		if (documentModel.File == undefined)
			documentModel.File = { FileName: file.name };
		else
			documentModel.File.FileName = file.name;
		this.setState({ fileModel: file, documentModel });
	}

	OperationCheck = () => {

		var ErrorList = [];
		const data = this.state.documentModel;
		let { vModel } = this.state;

		if (data == null) {
			ErrorList.push("Document model not defined.");
		}
		if (data != null && (data.DocumentTypeId == null || data.DocumentTypeId == "")) {
			vModel.DocumentTypeId = true;
			ErrorList.push("Document type must be defined.");
		} else {
			vModel.DocumentTypeId = false;
		}

		this.setState({ vModel });
		if (ErrorList.length > 0) {
			this.ShowMessageNode("warning", "Please Fill Required Fields", ErrorList.map((x, i) => <div key={i}>{x}</div>));
			return false;
		}

		this.UpdateModel();
	}
	ShowMessageNode = (type, title, message) => {
		this.setState({
			alert: <GenericAlert Title={title} MessageNode={message} Type={type} OnConfirm={() => this.hideAlert()} />
		});
		this.setState({ isLoading: false });
	}

	UpdateModel = () => {
		var { ApplicationModel } = this.props;

		var temp = this.state.documentModel;
		temp.ApplicationId = ApplicationModel.Id;
		this.props.TaskPoolFunc.AppendTask(
			Proxy.POST(
				"/losapi/v1.0/ApplicationDocument/InsertUpdate",
				temp,
				responseData => {
					if (!responseData.IsSucceeded) {
						this.ShowMessage("error", "Error", responseData.ErrorDescription);
						return;
					}
					this.UpdateFile(responseData.Item.Id);
				},
				error => {
					this.ShowMessage("error", "Error", error);
				}
			));
	}
	UpdateFile = (documentId) => {
		var formData = new FormData();
		formData.append("file", this.state.fileModel, String(this.state.fileModel.name));
		formData.append("documentId", String(documentId));
		this.props.TaskPoolFunc.AppendTask(
			Proxy.FileUpload(
				"/losapi/v1.0/ApplicationDocument/UploadFile",
				formData,
				responseData => {
					if (!responseData.IsSucceeded) {
						this.ShowMessage("error", "Error", responseData.ErrorDescription);
						return;
					}
					this.ShowMessage("success", "Success", this.state.documentModel.Id > 0 ? "Document Updated" : "Document Saved");
					this.ClearData();
					this.props.GetApplicationDocumentModels();
				},
				error => {
					this.ShowMessage("error", "Error", error);
				}
			));
	}
	DeleteModel = (model) => {
		if (model == null || model.Id == null || model.Id == 0) {
			this.ShowMessage("warning", "Warning", "Document must be selected for delete operation.");
			return;
		}
		this.props.TaskPoolFunc.AppendTask(
			Proxy.POST(
				"/losapi/v1.0/ApplicationDocument/Delete",
				{ Id: model.Id },
				responseData => {
					if (!responseData.IsSucceeded) {
						this.ShowMessage("error", "Error", responseData.ErrorDescription);
						return;
					}
					this.ShowMessage("success", "Success", "Application Document Deleted");
					this.ClearData();
					this.props.GetApplicationDocumentModels();
				},
				error => {
					this.ShowMessage("error", "Error", error);
				}
			));
	}
	SelectedRowChange = (e, index) => {
		const model = this.props.ApplicationDocumentList[index];
		this.setState({ documentModel: model || {} });
	}
	ClearData = () => {
		var model = { Id: 0 };
		this.setState({ fileModel: undefined, documentModel: model });
	}
	handleChange = (name, newValue, data) => {
		this.setState(function (state, props) {
			var model = state.documentModel || {};
			model[name] = newValue;
			return { documentModel: model };
		});
	}

	showQuestionMessage = (message, model) => {
		this.setState({
			alert: <GenericAlert Title="Delete" Message={message} Type="warning" ShowCancel={true} OnCancel={() => this.hideAlert()} OnConfirm={() => this.DeleteModel(model)} />
		});
		this.setState({ isLoading: false });
	}
	ShowMessage = (type, title, message) => {
		// type:-success->warning->info->error
		this.setState({
			alert: <GenericAlert Title={title} Message={message} Type={type} OnConfirm={() => this.hideAlert()} />
		});
		this.setState({ isLoading: false });
	}
	hideAlert = () => {
		this.setState({
			alert: null,
			isLoading: false
		});
	}
	DownloadFile = (index) => {
		this.props.TaskPoolFunc.AppendTask(
			Proxy.FileDownloadWithGenericResponse(
				"/coreapi/v1.0/File/DownloadFileFromBinary",
				index.File.FileName,
				index.File.FileExtension.ParameterDesc,
				{
					"FileId": index.FileId
				},
				() => {
				},
				(error) => {
					this.ShowMessage("error", "An error occurred while sending data", error.message);
				}
			));
	}
	GetRenderItemClientUserSelect(d) {
		return `${d.FirstName} - ${d.LastName}`;
	}

	render() {
		const { Disabled: DisabledProp, ApplicationDocumentList } = this.props;
		const { vModel, fileModel } = this.state;
		const { documentModel } = this.state;
		const Disabled = DisabledProp || this.state.CustomDisabled;

		return (
			<GridContainer spacing={16}>
				{this.state.alert}

				<LoadingComponent Show={this.state.isLoading} />

				<GridItem xs={12}>
					<GridContainer>
						<GridItem xs={4}>
							<GenericSelectInput
								Name="DocumentTypeId"
								LabelText="Document Type"
								Value={documentModel == null ? "" : documentModel.DocumentTypeId || ""}
								ValueChanged={this.handleChange}
								KeyValueMember="Id"
								TextValueMember="ParameterDesc"
								Method="POST"
								IsStatic={true}
								StaticData={this.props.ParameterList.filter(prm => prm.ParameterCode == this.ParameterDocumentType.ParameterCode)}
								Disabled={Disabled}
								DataRoot="Item"
								Required
								IsInvalid={vModel.DocumentTypeId} />
							<GenericSelectInput
								Name="VerificationStatusId"
								LabelText="Verification Status"
								Value={documentModel == null ? "" : documentModel.VerificationStatusId || ""}
								ValueChanged={this.handleChange}
								KeyValueMember="Id"
								TextValueMember="ParameterDesc"
								Method="POST"
								IsStatic={true}
								StaticData={this.props.ParameterList.filter(prm => prm.ParameterCode == this.ParameterDocumentVerifiedStatusType.ParameterCode)}
								Disabled={Disabled}
								DataRoot="Item" />
							<GenericSelectInput
								Name="VerifiedPersonId"
								LabelText="Verified Person"
								Value={documentModel == null ? "" : documentModel.VerifiedPersonId || ""}
								ValueChanged={this.handleChange}
								KeyValueMember="Id"
								Url="/coreapi/v1.0/User/Search"
								Method="POST"
								Disabled={Disabled}
								DataRoot="Item"
								Parameter={{ UniqueClientId: ClientHelper.GetClientRowId(), UserStatusList: [ UserStatus.Ok ] }}
								RenderItem={this.GetRenderItemClientUserSelect}
							/>

						</GridItem>
						<GridItem xs={2}>
							<GenericLabel Text="Upload File" />
							<Button onClick={this.UploadClick} disabled={Disabled || documentModel == null ||
								(documentModel.DocumentTypeId == undefined || documentModel.DocumentTypeId == 0) ||
								(documentModel.VerificationStatusId == undefined || documentModel.VerificationStatusId == 0) ||
								(documentModel.VerifiedPersonId == undefined || documentModel.VerifiedPersonId == 0)} style={{ marginLeft: "16px" }}>Browse</Button>
							<input key={documentModel.FileName} type="file" style={{ display: "none" }} onChange={this.FileSelect} ref={this.fileInputRef}
								accept=".pdf" />
						</GridItem>
						<GridItem xs={4}>
							<GenericTextInput
								key={this.state.uniq}
								Name="FileName"
								LabelMd={5}
								LabelText="File Name"
								Value={documentModel.File == null || documentModel.File.FileName == null || undefined ? "" : documentModel.File.FileName}
								Disabled={true} />
						</GridItem>

					</GridContainer>
					<GridContainer justify="flex-end">
						<GridItem>
							<Button disabled={Disabled} size="sm" color="black" onClick={() => this.ClearData()}>	Clear	</Button>
							<Button disabled={Disabled || documentModel == null || !fileModel ||
								(documentModel.DocumentTypeId == undefined || documentModel.DocumentTypeId == 0) ||
								(documentModel.VerificationStatusId == undefined || documentModel.VerificationStatusId == 0) ||
								(documentModel.VerifiedPersonId == undefined || documentModel.VerifiedPersonId == 0)} size="sm" color="black" onClick={() => this.OperationCheck()}>{documentModel.Id > 0 ? "Update" : "Add"}</Button>
						</GridItem>
					</GridContainer>
				</GridItem>
				<GridItem xs={12}>
					<GridItem xs={12}>
						<GenericTitle text={"Document List"} />
					</GridItem>
					<GridItem xs={12}>
						<GridItem>
							<GenericGrid
								Data={ApplicationDocumentList}
								PageSize={5}
								HideButton={true}
								Columns={this.ColumnsData}
								RowSelected={index => {
									this.SelectedRowChange(0, index);
								}}
							/>
						</GridItem>
					</GridItem>

				</GridItem>
			</GridContainer >
		);
	}
}

PaymentAdminDocument.propTypes = {
	classes: PropTypes.object,
	documentModel: PropTypes.object,
	ApplicationModel: PropTypes.object,
	paramApplicationProfile: PropTypes.object,
	ApplicationDocumentList: PropTypes.array,
	GetApplicationDocumentModels: PropTypes.func,
	paramBankApplicationStoreList: PropTypes.array,
	handleChangeParentTab: PropTypes.func,
	handleChangeChildTab: PropTypes.func,
	SetFile: PropTypes.func,
	ParameterList: PropTypes.array,
};

export default withArtifex(PaymentAdminDocument, {});